import { render, staticRenderFns } from "./PicacodeReleaseLabelsGenerationModal.vue?vue&type=template&id=7fab3b46&"
import script from "./PicacodeReleaseLabelsGenerationModal.vue?vue&type=script&lang=js&"
export * from "./PicacodeReleaseLabelsGenerationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports